import { DEFAULT_USAGE_SYSTEM_LOG_FILTER } from 'constants/common'
import UsageSystemLogTypes from 'store/actionTypes/usageSystemLog'
import UserTypes from 'store/actionTypes/user'

const initialData = Object.freeze({
  list: [],
  current: {},
  pagination: {},
  filter: DEFAULT_USAGE_SYSTEM_LOG_FILTER
})

const usageSystemLog = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case UsageSystemLogTypes.GET_USAGE_SYSTEM_LOGS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case UsageSystemLogTypes.GET_DETAIL_USAGE_SYSTEM_LOG_SUCCESS:
      return {
        ...state,
        current: payload?.keyUsageSystemLogs || {}
      }
    case UsageSystemLogTypes.UPDATE_FILTER_USAGE_SYSTEM_LOG_SUCCESS:
      return { ...state, filter: payload?.value }
    case UsageSystemLogTypes.CLEAR_FILTER_USAGE_SYSTEM_LOG_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default usageSystemLog
